import { css } from '@emotion/css';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { interpolateFreeText } from '../../../i18n';
import { Notification } from '../../../models/Notification';
import { NotificationIcon } from './NotificationIcon';

interface NotificationListItemProps {
  type: Notification['type'];
  message: string;
  asCard?: boolean; // ホーム画面で通知カードとして表示するかどうか
  moreCount?: number;
}

export const NotificationListItem: React.FC<NotificationListItemProps> = ({
  type,
  message,
  asCard,
  moreCount
}) => {
  const { t } = useTranslation('notification');
  return (
    <div
      className={css`
        display: flex;
        align-items: center;
        min-height: 88px;
        border-radius: 44px;
        background: rgba(255, 255, 255, 0.9);
        box-shadow: ${asCard ? '0px 0px 12px rgba(0, 0, 0, 0.1)' : 'none'};
        margin: 0 0 16px;
        padding: 12px;
        .texts {
          flex: 1 1 auto;
          display: flex;
          flex-direction: column;
          margin: 0 0 0 12px;
          padding: 0 4px 0 0;
        }
        p {
          font-size: 14px;
          color: #4d3906;
        }
        .block-ellipsis {
          display: block;
          max-width: 100%;
          font-size: 14px;
          line-height: 1.4;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }
        .more {
          font-size: 12px;
          margin: 4px auto 0 0;
          color: #938666;
        }
        @media (max-width: 320px), (max-height: 580px) {
          p {
            font-size: 12px;
          }
          .block-ellipsis {
            max-height: calc(12px * 1.4 * 2);
            font-size: 12px;
            line-height: 1.2;
          }
        }
      `}
    >
      <NotificationIcon type={type} style={{ flex: '0 0 auto' }} />
      <div className="texts">
        <p className={asCard ? 'block-ellipsis' : ''}>{message}</p>
        {asCard && moreCount && (
          <span className="more">
            {interpolateFreeText(t, 'more_count', 'count', moreCount.toString())}
          </span>
        )}
      </div>
    </div>
  );
};
